function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  signUp: path(ROOTS_AUTH, '/sign-up'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_PAGE = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    // Keep the dashboard app under /dashboard
    app: path(ROOTS_DASHBOARD, '/app'),
    dashboard2: path(ROOTS_DASHBOARD, '/dashboard2'),
    // Expose primary pages at root-level paths (no /dashboard prefix)
    restaurantListings: '/restaurant-listings',
    restaurantCreate: '/restaurant/create',
    tourListings: '/tour-listings',
    tourCreate: '/tour/create',
    restaurantDetails: (id) => `/restaurant/${id}`,
    tourDetails: (id) => `/tour/${id}`,
    account: '/account',
  },
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
};
